import apiAuctions from '../../api/apiAuctions'

const state = {
    isActive: false,
    activeLotId: '',
    isLoading: false,
    selectedLot: null,
    totalLots: null,
    currentPage: 1,
    lastPage: 1,
    lots: [],
    query: {
        order_column: 'AUCTION_DATE',
        order_type: 'DESC',
        limit_start: 0,
        limit_end: 30
    }
}

const getters = {
    getMarketPriceModalLoadingStatus: (state) => {
        return state.isLoading
    },
    getMarketPriceModalLots: (state) => {
        return state.lots
    },
    getMarketPriceModalTotalLots: (state) => {
        return state.totalLots
    },
    getMarketPriceModalSelectedLot: (state) => {
        return state.selectedLot
    },
    getActiveMarketPriceModalLotId: (state) => {
        return state.activeLotId
    },
    getMarketPriceModalStatus: (state) => (lotId) => {
        return state.isActive && state.activeLotId === lotId
    },
    getActiveMarketPriceModalStatus: (state) => {
        return state.isActive
    },
    getActiveMarketPriceModalCurrentPage: (state) => {
        return state.currentPage
    },
    getActiveMarketPriceModalLastPage: (state) => {
        return state.lastPage
    }
}

const mutations = {
    setMarketPriceModalQueryFieldValue: (state, data) => {
        state.query[data.field] = data.value
    },
    setMarketPriceModalStatus: (state, newStatus) => {
        state.isActive = newStatus.status
        state.activeLotId = newStatus.lotId
    },
    setMarketPriceModalLots: (state, data) => {
        state.lots = data
    },
    setMarketPriceModalTotalLots: (state, data) => {
        state.totalLots = data
    },
    setMarketPriceModalSelectedLot: (state, data) => {
        state.selectedLot = data
    },
    setMarketPriceModalLoadingStatus: (state, data) => {
        state.isLoading = data
    },
    setMarketPriceModalCurrentPage: (state, data) => {
        state.currentPage = data
    },
    setMarketPriceModalLastPage: (state, data) => {
        state.lastPage = data
    },
    setMarketPriceModalQueryOrderType: (state) => {
        state.query.order_type = state.query.order_type === 'DESC' ? 'ASC' : 'DESC'
    },
    setMarketPriceModalQueryToDefault: (state) => {
        state.query = {
            order_column: 'AUCTION_DATE',
            order_type: 'DESC',
            limit_start: 0,
            limit_end: 30
        }
    }
}

const actions = {
    changeMarketPriceModalStatus: ({ commit }, newStatus) => {
        commit('setMarketPriceModalStatus', newStatus)
    },
    changeMarketPriceModalQueryFieldValue: ({ commit }, data) => {
        commit('setMarketPriceModalQueryFieldValue', data)
    },
    changeMarketPriceModalQueryOrderType: ({ commit }) => {
        commit('setMarketPriceModalQueryOrderType')
    },
    changeMarketPriceModalSelectedLot: ({ commit }, data) => {
        commit('setMarketPriceModalSelectedLot', data)
    },
    resetMarketPriceModalQuery: ({ commit }) => {
        commit('setMarketPriceModalQueryToDefault')
    },
    fetchMarketPriceModalLots: ({ commit, state })  => {
        commit('setMarketPriceModalLoadingStatus', true)
        apiAuctions
            .getMarketPrice(state.activeLotId, state.query)
            .then((response) => {
                commit('setMarketPriceModalLots', response.data.lots)
                commit('setMarketPriceModalTotalLots', response.data.total_lots)
                commit('setMarketPriceModalCurrentPage', response.data.current_page)
                commit('setMarketPriceModalLastPage', response.data.last_page)
                commit('setMarketPriceModalLoadingStatus', false)
            })
            .catch(error => console.log(error))
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/marketPriceModal.js